import axios from "axios";
import safeStorage from '../utility/safeStorage'

const API_URL = import.meta.env.VITE_API_BASE_URL;
const userId = safeStorage.getItem("userId");

export const logClientError = async (data) => {
    try {
        await axios.post(`${API_URL}Log/ClientError`, {
            ...data,
            userId,
            url: window.location.href,
            userAgent: navigator.userAgent,
            time: new Date().toISOString(),
        });
    } catch {
        // Never throw while logging
    }
};